import { useState, useContext, useCallback } from 'react';
import { LoaderContext } from 'shared/context/loaderContext';
import { NotificationContext } from 'shared/context/notificationContext';
import { useCm360Api } from '../../../../shared/const/api-backend';
import { reportError } from 'shared/services/raygunService';

const useFetchPayments = () => {
  const [error, setError] = useState(null);
  const [payments, setPayments] = useState(null);
  const { showNotification } = useContext(NotificationContext);
  const { setLoading } = useContext(LoaderContext);

  const API = useCm360Api();

  const fetchPayments = useCallback(async (bookingDataId) => {
    try {
      setLoading(true);
      const apiUrl = `/booking/${bookingDataId}/payment`;
      const response = await API.get(apiUrl);
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const responseData = response.data;
      if (!responseData || responseData.length === 0) {
        return [];
      }
      const paymentsArray = [];

      // Sort by createdDate (oldest first)
      const sortedData = [...responseData].sort((a, b) => {
        const dateA = new Date(a.createdDate);
        const dateB = new Date(b.createdDate);
        return dateA - dateB;
      });

      sortedData.forEach((payment) => {
        let transactionType = 'subscription';

        if (/modification/i.test(payment.message)) {
          transactionType = `amendment`;
        }

        if (/cancellation/i.test(payment.message)) {
          transactionType = 'cancellation';
        }

        const salePayment = {
          ...payment,
          transactionId:
            payment.paymentProvider === 'ON_ACCOUNT'
              ? 'On account'
              : payment.transactionId,
          transactionType,
        };

        paymentsArray.push(salePayment);
      });

      setPayments(paymentsArray);
      return paymentsArray;
    } catch (error) {
      setError(error);
      showNotification('Error fetching payment data', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { payments, error, fetchPayments };
};

export default useFetchPayments;
